import {cssTheme} from '@logistics-frontend/blocks/theme'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

import angle from '../assets/angle.svg'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(2)};
    filter: drop-shadow(0px 8px 20px rgba(0, 0, 0, 0.12));
    padding: ${spacing(1.75, 2)};
    cursor: pointer;
    position: relative;

    &::before {
      background-color: transparent;
      background-image: url(${angle});
      background-position: 0 0;
      background-repeat: no-repeat;
      content: '';
      display: block;
      height: ${spacing(4)};
      position: absolute;
      left: ${spacing(-3.5)};
      top: ${spacing(1.125)};
      width: ${spacing(4)};
    }
  `,
  downloadButton: css`
    background-color: ${cssTheme.colors.blue.toxic};
    border-radius: ${spacing(12.5)};
    border: unset;
    cursor: pointer;
    height: ${spacing(4)};
    padding: ${spacing(0, 1.75)};
  `,
}
